import { useEffect, useState } from 'react';
import { Button, Col, DropdownButton } from 'react-bootstrap';
import { subDays } from 'date-fns/esm/fp'
import { Link } from "react-router-dom";
import { useLocation, useNavigate, useParams } from "react-router";
import { useTranslation } from 'react-i18next';
import { FiChevronDown, FiChevronUp, FiEdit2, FiPlus, FiSliders } from "react-icons/fi";
import { RxExternalLink } from "react-icons/rx";
import { RiSearch2Line } from "react-icons/ri";
import "./campaigndetails.scss";
import WebServiceAmazon from '../../../Services/WebServiceAmazon';
import { toast } from 'react-toastify';
import TableLoader from '../../Common/TableLoader/TableLoader';
import NoDataFound from "../../../assets/images/empty_item.svg";
import OverviewCards from './Common/OverviewCards';
import HelperService from '../../../Services/HelperService';
import moment from 'moment';
import WebService from '../../../Services/WebService';
import { IoClose } from 'react-icons/io5';
import { useSelector } from "react-redux";
import AmazonSelectedCampaign from '../AmazonSelectedCampaign';
import { TooltipCustom } from '../../Common/Tooltip/Tooltip';
import CampaignDropDown from '../../AmazonAccounts/CampaignDropDown/CampaignDropDown';
import { TbCloudUpload } from 'react-icons/tb';
import FilterMain from '../FilterComponents/FilterMain';
import LineChart from '../../Common/LineChart/LineChart';
import LineChartHighChart from '../../Common/LineChartHighChart/LineChartHighChart';
import AddAdGroupDrawer from './AddAdGroupDrawer';
import {
  TableColumnDef,
  getVisibleColumns,
} from "../../../utils/tableColumns";
import { useTableColumns } from "../../../hooks/useTableColumns";
import EditColumnsPanel from "../../Common/EditColumnsPanel";

const COLUMN_STORAGE_KEY = "pref.amazonAdGroups.columnConfig.v1";
const DEFAULT_COLUMN_ORDER = [
    "status",
    "name",
    "campaignName",
    "campaignType",
    "targetingType",
    "defaultBid",
    "ACOS",
    "ROAS",
    "impressions",
    "sales",
    "spend",
    "orders",
    "clicks",
    "cpc",
    "ctr",
    "detailPageViews",
    "addToCart",
    "brandedSearches",
    "newToBrandSales",
    "newToBrandPurchases",
    "newToBrandPercentage",
];
// Opt-in columns — come in hidden so existing users keep the current view.
const DEFAULT_HIDDEN_COLUMNS = [
    "campaignType",
    "targetingType",
    "cpc",
    "ctr",
    "detailPageViews",
    "addToCart",
    "brandedSearches",
    "newToBrandSales",
    "newToBrandPurchases",
    "newToBrandPercentage",
];

const AdGroupsList = (props: any) => {
    const location = useLocation();
    const navigate = useNavigate()
    let overviewObject = {
        "ACOS": 0,
        "profit": 0,
        "spend": 0,
        "sales": 0,
        "clicks": 0,
        "impressions": 0
    }
    let filterObject = {
        campaign: [],
        adGroup: [],
        campaignType: [],
        status: [],
        bid: {},
        spend: {},
        sales: {},
        ACOS: {},
        clicks: {},
        budget: {},
        impressions: {},
        purchases: {},
    };
    const { t } = useTranslation();
    const [loader, setLoader] = useState(false);
    const [keyword, setKeyword] = useState<any>("");
    const [overview, setOverview] = useState<any>(overviewObject);
    const [list, setList] = useState<any[]>([]);
    // const [status, setStatus] = useState<any>("");
    const [filters, setFilters] = useState<any>(filterObject);
    const [bid, setBid] = useState<any>(0);
    const [currentColum, setcurrentColum] = useState("name");
    const [currentSort, setcurrentSort] = useState("DESC");
    var profileData = useSelector((state: any) => state.commonReducer.data) || null;
    var portfolioData = useSelector((state: any) => state.commonReducer.portfolio) || null;
    var date_range = useSelector((state: any) => state.commonReducer.range) || {
        startDate: subDays(7, new Date()),
        endDate: new Date(),
        key: 'selection'
    };
    const campaignData =
        useSelector((state: any) => state.commonReducer.campaign) || null;
    const brandAccess = useSelector((state: any) => state.auth.access);
    const [graphType, setGraphType] = useState<any>("Weekly");
    const [graphloader, setGraphloader] = useState(false);
    const [graphData, setGraphData] = useState<any>(null);
    const [rowUpdating, setRowUpdating] = useState<any>(null);
    const [showAddAdGroup, setShowAddAdGroup] = useState<boolean>(false);

    const tableCols = useTableColumns({
        storageKey: COLUMN_STORAGE_KEY,
        defaultOrder: DEFAULT_COLUMN_ORDER,
        defaultHidden: DEFAULT_HIDDEN_COLUMNS,
    });

    const panelColumns: TableColumnDef<any>[] = [
        { key: "status", label: "Status", renderCell: () => null },
        { key: "name", label: "Ad Group", renderCell: () => null },
        { key: "campaignName", label: "Campaign", renderCell: () => null },
        { key: "campaignType", label: "Campaign Type", renderCell: () => null },
        { key: "targetingType", label: "Targeting Type", renderCell: () => null },
        { key: "defaultBid", label: "Default Bid", renderCell: () => null },
        { key: "ACOS", label: "ACOS", renderCell: () => null },
        { key: "ROAS", label: "ROAS", renderCell: () => null },
        { key: "impressions", label: "Impressions", renderCell: () => null },
        { key: "sales", label: "Sales", renderCell: () => null },
        { key: "spend", label: "Spend", renderCell: () => null },
        { key: "orders", label: "Orders", renderCell: () => null },
        { key: "clicks", label: "Clicks", renderCell: () => null },
        { key: "cpc", label: "CPC", renderCell: () => null },
        { key: "ctr", label: "CTR", renderCell: () => null },
        { key: "detailPageViews", label: "Detail Page Views", renderCell: () => null },
        { key: "addToCart", label: "Add to Cart", renderCell: () => null },
        { key: "brandedSearches", label: "Branded Searches", renderCell: () => null },
        { key: "newToBrandSales", label: "NTB Sales", renderCell: () => null },
        { key: "newToBrandPurchases", label: "NTB Orders", renderCell: () => null },
        { key: "newToBrandPercentage", label: "NTB %", renderCell: () => null },
    ];

    useEffect(() => {
        getList();
    }, [date_range, profileData, portfolioData, currentColum, currentSort, campaignData, filters]);

    useEffect(() => {
        if (props?.come_from !== "CAMPAIGN_DETAILS") getGraphData();
    }, [date_range, profileData, portfolioData, graphType]);
    const searchList = (e: any) => {
        if (e.which === 13) {
            setKeyword(e.target.value);
            getList();
        }
    };
    const sorting = (sort_by: any, colum_name: any) => {
        var sortBy = sort_by;
        if (currentColum !== colum_name) {
            sortBy = "DESC";
        } else {
            if (currentSort === "DESC") {
                sortBy = "ASC";
            } else {
                sortBy = "DESC";
            }
        }
        sort_by = sortBy;
        setcurrentSort(sortBy);
        setcurrentColum(colum_name);
    }
    const getList = () => {
        let body = {
            name: keyword,
            state: filters?.status || [],
            campaign_id: (props?.come_from === "CAMPAIGN_DETAILS") ? (campaignData?.campaignId ?? "") : "",
            profileId: profileData?.value ?? '',
            portfolioId: portfolioData?.value ?? '',
            sort_by: currentColum,
            order_by: currentSort,
            start_date: moment(date_range.startDate).format("YYYY-MM-DD"),
            end_date: moment(date_range.endDate).format("YYYY-MM-DD"),
            filterCampaignIds: filters?.campaign?.length > 0 ? filters?.campaign?.map((item: any) => item.campaignId) : [],
            filterAdgroupIds: filters?.adGroup?.length > 0 ? filters?.adGroup?.map((item: any) => item.adGroupId) : [],
            filters: JSON.stringify({
                ...(Object.keys(filters.spend).length > 0 && { spend: filters.spend }),
                ...(Object.keys(filters.sales).length > 0 && { sales: filters.sales }),
                ...(Object.keys(filters.ACOS).length > 0 && { ACOS: filters.ACOS }),
                ...(Object.keys(filters.clicks).length > 0 && { clicks: filters.clicks }),
                ...(Object.keys(filters.budget).length > 0 && { budget: filters.budget }),
                ...(Object.keys(filters.impressions).length > 0 && { impressions: filters.impressions }),
                ...(Object.keys(filters.purchases).length > 0 && { purchases: filters.purchases }),
                ...(Object.keys(filters.bid).length > 0 && { defaultBid: filters.bid }),
            }),
        }
        let qurey = new URLSearchParams(body).toString();
        setLoader(true)
        return WebServiceAmazon.getAPI({
            action: `amazon/groups?` + qurey,
            body: null,
        }).then((res: any) => {
            res.data.length > 0 ?
                setList(res.data) : setList([])
            if (res?.overview && Object.keys(res.overview)?.length > 0) {
                setOverview(res?.overview);
            } else {
                setOverview(overviewObject);
            }
            // getOverview(date)
            setLoader(false)
        }).catch((error) => {
            setLoader(false)
            return error;
        });
    };

    const getGraphData = () => {
        let body = {
            name: keyword,
            state: filters?.status || [],
            campaign_id: (props?.come_from === "CAMPAIGN_DETAILS") ? (campaignData?.campaignId ?? "") : "",
            profileId: profileData?.value ?? '',
            portfolioId: portfolioData?.value ?? '',
            graphType: graphType,
            start_date: moment(date_range.startDate).format("YYYY-MM-DD"),
            end_date: moment(date_range.endDate).format("YYYY-MM-DD"),
            filterCampaignIds: filters?.campaign?.length > 0 ? filters?.campaign?.map((item: any) => item.campaignId) : [],
            filterAdgroupIds: filters?.adGroup?.length > 0 ? filters?.adGroup?.map((item: any) => item.adGroupId) : [],
            filters: JSON.stringify({
                ...(Object.keys(filters.spend).length > 0 && { spend: filters.spend }),
                ...(Object.keys(filters.sales).length > 0 && { sales: filters.sales }),
                ...(Object.keys(filters.ACOS).length > 0 && { ACOS: filters.ACOS }),
                ...(Object.keys(filters.clicks).length > 0 && { clicks: filters.clicks }),
                ...(Object.keys(filters.budget).length > 0 && { budget: filters.budget }),
                ...(Object.keys(filters.impressions).length > 0 && { impressions: filters.impressions }),
                ...(Object.keys(filters.purchases).length > 0 && { purchases: filters.purchases }),
                ...(Object.keys(filters.bid).length > 0 && { defaultBid: filters.bid }),
            }),
        }
        let qurey = new URLSearchParams(body).toString();
        setGraphloader(true)
        return WebServiceAmazon.getAPI({
            action: `amazon/groups/graph-v2?` + qurey,
            body: null,
        }).then((res: any) => {
            if (res?.data) {
                setGraphData(res?.data);
            } else {
                setGraphData(null);
            }
            setGraphloader(false)
        }).catch((error) => {
            setGraphloader(false)
            return error;
        });
    };

    const getOverview = (date: any) => {
        const queryData = {
            profileId: profileData.value,
            campaignId: campaignData?.campaignId ?? "",
            portfolioId: portfolioData?.value ?? '',
            start_date: moment(date_range.startDate).format("YYYY-MM-DD"),
            end_date: moment(date_range.endDate).format("YYYY-MM-DD"),
            name: keyword,
        };
        let qurey = new URLSearchParams(queryData).toString();
        WebServiceAmazon.getAPI({
            action: `amazon/overview?` + qurey,
            body: null,
        }).then((res: any) => {
            res.data.length > 0 ?
                setOverview(res.data[0]) : setOverview(overviewObject)
        }).catch((error) => { });
    };

    const redirctToDetails = (data1: any) => {
        navigate("/ad-group-details/" + data1.adGroupId, { state: data1 })
    }

    const redirctToCampaignDetails = (data1: any) => {
        navigate("/campaign-details/" + data1.campaignId)
    }
    // const onChangeListStatus = (event: any) => {
    //     if (event.target.checked) {
    //         setStatus('ENABLED')
    //     } else {
    //         setStatus('')
    //     }
    // };

    const onStatusChange = (item: any, type: any) => {


        let st = item.state
        if (type != 'BUDGET') {
            if (st == 'PAUSED') {
                st = 'ENABLED'
            } else {
                st = 'PAUSED'
            }
            setRowUpdating(item.adGroupId)
        }
        let logData = {
            type: type != 'BUDGET' ? 'ADGROUP_STATUS' : 'ADGROUP_BID',
            ref_id: item.adGroupId,
            ref_name: item.name,
            previous_value: type != 'BUDGET' ? item?.state : item?.defaultBid,
            current_value: type != 'BUDGET' ? st : bid,
        }
        let body = {
            adGroupId: item.adGroupId,
            defaultBid: type == 'BUDGET' ? bid : item.defaultBid,
            name: item.name,
            state: st,
            is_update: true,
            type: item.groupType,
            log_data: logData
        }
        if (type == 'BUDGET') {
            WebService.addLoader('savebgt')
        }
        WebServiceAmazon.putAPI({
            action: `amazon/groups/update-group?profileId=` + profileData?.value,
            body: body,
        }).then((res: any) => {
            if (type == 'BUDGET') {
                WebService.removeLoader('savebgt')
            }
            toast.success(res.message)
            setRowUpdating(null);
            getList();
        }).catch((error) => {
            if (type == 'BUDGET') {
                WebService.removeLoader('savebgt')
            }
            setRowUpdating(null);
        });
    };

    const onClose = (i: number) => {
        const dropdown = document.getElementById(`dropdown-button-drop_${i}`);
        if (dropdown != null) {
            dropdown.click();
            // dropdown.classList.remove("dropdown-toggle");
        }
    };

    const exportData = async () => {
        const filename = `amazon_ad_groups_${moment(date_range.startDate).format("YYYY-MM-DD")}_${moment(date_range.endDate).format("YYYY-MM-DD")}.xlsx`;
        const body = {
            name: keyword,
            state: filters?.status || [],
            campaign_id: (props?.come_from === "CAMPAIGN_DETAILS") ? (campaignData?.campaignId ?? "") : "",
            profileId: profileData?.value ?? '',
            portfolioId: portfolioData?.value ?? '',
            sort_by: currentColum,
            order_by: currentSort,
            start_date: moment(date_range.startDate).format("YYYY-MM-DD"),
            end_date: moment(date_range.endDate).format("YYYY-MM-DD"),
            filterCampaignIds: filters?.campaign?.length > 0 ? filters?.campaign?.map((item: any) => item.campaignId) : [],
            filterAdgroupIds: filters?.adGroup?.length > 0 ? filters?.adGroup?.map((item: any) => item.adGroupId) : [],
            filters: JSON.stringify({
                ...(Object.keys(filters.spend).length > 0 && { spend: filters.spend }),
                ...(Object.keys(filters.sales).length > 0 && { sales: filters.sales }),
                ...(Object.keys(filters.ACOS).length > 0 && { ACOS: filters.ACOS }),             
                ...(Object.keys(filters.clicks).length > 0 && { clicks: filters.clicks }),             
                ...(Object.keys(filters.budget).length > 0 && { budget: filters.budget }),             
                ...(Object.keys(filters.impressions).length > 0 && { impressions: filters.impressions }),             
                ...(Object.keys(filters.purchases).length > 0 && { purchases: filters.purchases }),
                ...(Object.keys(filters.bid).length > 0 && { defaultBid: filters.bid }),             
            }),
            isExport: true,
            app_id1: localStorage.getItem("app_id") ?? "",
        };
        HelperService.exportData(body,filename,'amazon/groups');
    };

    return (
        <>


            <div className='d-flex justify-content-between align-items-center'>
                <Col md={4} className='table-heading mb-3' >
                    <div className="align-items-center d-flex justify-content-start gap-2">
                        <div>
                            <h2 className="table-heading">Ad Groups</h2>
                        </div>
                        {props?.come_from !== "CAMPAIGN_DETAILS" && (
                            <div>
                                {/* <AmazonSelectedCampaign /> */}
                            </div>
                        )}
                    </div>
                </Col>
                <Col md={8} className="d-flex justify-content-end">
                    {/* <div className="pt-2 me-3">
                        <div className="form-check form-switch">
                            <input className="form-check-input" onChange={(event: any) => { onChangeListStatus(event) }} type="checkbox" role="switch" id="flexSwitchCheckDefault" />
                            <label className="form-check-label text-nowrap" htmlFor="flexSwitchCheckDefault">Only active Ad Groups</label>
                        </div>
                    </div> */}
                    {/* {props?.come_from !== "CAMPAIGN_DETAILS" && (
                        <CampaignDropDown />
                    )} */}

                    <Button
                        className='btn btn-filter me-2'
                        onClick={() => tableCols.setShowPanel(true)}
                        title="Show / hide / reorder columns"
                    >
                        <FiSliders size={16} /> Columns
                    </Button>

                    {props?.come_from !== "CAMPAIGN_DETAILS" && (
                        <Button
                            className='btn btn-filter me-2'
                            onClick={exportData}
                            disabled={list.length == 0}
                        >
                            <TbCloudUpload size={18} /> Export
                        </Button>
                    )}

                    <div className="table-search-input input-group me-2">
                        <span className="input-group-text"><RiSearch2Line size="20" /></span>
                        <input placeholder="Search" onChange={(event) => {
                            setKeyword(event.target.value);
                        }}
                            onKeyDown={searchList} className="form-control" />
                    </div>
                    {props?.come_from === "CAMPAIGN_DETAILS" &&
                        (brandAccess?.can_full_access || brandAccess?.can_write) && (
                            <Button
                                className='btn btn-wmx'
                                onClick={() => setShowAddAdGroup(true)}
                            >
                                <FiPlus size={18} className="icon" /> {t("Add")}
                            </Button>
                        )}
                </Col>
            </div>
            <div className="mt-2">
                <Col lg={12} sm={12} className="mb-3">
                    <OverviewCards overview={overview} />
                </Col>
                {props?.come_from !== "CAMPAIGN_DETAILS" &&
                    <>
                        {graphloader ? (
                            <TableLoader />
                        ) :
                            <Col lg={12} sm={12}>
                                <LineChartHighChart data={graphData} onTypeChange={(type: any) => {
                                    setGraphType(type);
                                }} type={graphType}/>
                            </Col>
                        }
                    </>
                }
            </div>

            <div className="table-responsive my-3">
                {loader ? <TableLoader /> :
                    
                    <div className="table-box">
                        <FilterMain filters={filters} resetObject={filterObject} setFilters={setFilters} page_type="AD_GROUPS" />
                        {list.length > 0 ?
                            <div style={{maxHeight: "56vh",}} className="overflow-auto">
                            <table className="wmx-table-style mb-0 table table-hover sticky-header">
                                {(() => {
                                    const columns: TableColumnDef<any>[] = [
                                        {
                                            key: "status",
                                            label: "Status",
                                            sortField: "state",
                                            renderCell: (item, i) =>
                                                rowUpdating === item.adGroupId ? (
                                                    <div
                                                        className="spinner-border spinner-border-sm text-primary"
                                                        role="status"
                                                    ></div>
                                                ) : (
                                                    <div className="form-check form-switch">
                                                        <input
                                                            className="form-check-input"
                                                            defaultChecked={item.state == 'ENABLED' ? true : false}
                                                            type="checkbox"
                                                            role="switch"
                                                            disabled={((brandAccess?.can_full_access || brandAccess?.can_write) && item.state != "ARCHIVED") ? false : true}
                                                            onChange={() => onStatusChange(item, 'STATUS')}
                                                            id={`adgroupStatus_${i}`}
                                                        />
                                                        <label className="form-check-label" htmlFor={`adgroupStatus_${i}`}>&nbsp;</label>
                                                    </div>
                                                ),
                                        },
                                        {
                                            key: "name",
                                            label: "Ad Group",
                                            sortField: "name",
                                            cellClassName: "text-nowrap font-medium green-text cursor-pointer",
                                            renderCell: (item, i) => (
                                                <span onClick={() => redirctToDetails(item)} style={{ display: "block" }}>
                                                    <TooltipCustom
                                                        st={
                                                            <span>
                                                                <RxExternalLink size="16" color='#0d6efd' />
                                                                {HelperService.truncate(item?.name, 20)}
                                                            </span>
                                                        }
                                                        message={item?.name}
                                                        position="top"
                                                        id={`adgroup-tooltip${i}`}
                                                    />
                                                </span>
                                            ),
                                        },
                                        {
                                            key: "campaignName",
                                            label: "Campaign",
                                            sortField: "campaignName",
                                            cellClassName: "text-nowrap font-medium green-text cursor-pointer",
                                            renderCell: (item, i) => (
                                                <span onClick={() => redirctToCampaignDetails(item)} style={{ display: "block" }}>
                                                    <TooltipCustom
                                                        st={
                                                            <span>
                                                                <RxExternalLink size="16" color='#0d6efd' />
                                                                {HelperService.truncate(item?.campaignName, 20)}
                                                            </span>
                                                        }
                                                        message={item?.campaignName}
                                                        position="top"
                                                        id={`campaignName-tooltip${i}`}
                                                    />
                                                </span>
                                            ),
                                        },
                                        {
                                            key: "defaultBid",
                                            label: "Default Bid",
                                            sortField: "defaultBid",
                                            cellClassName: "text-nowrap popover-box",
                                            renderCell: (item, i) => (
                                                <>
                                                    <span className="green-text font-medium">
                                                        ${item.defaultBid ? HelperService.numberWithCommas(Number(item.defaultBid)) : 0}
                                                    </span>
                                                    {(brandAccess?.can_full_access || brandAccess?.can_write) && (
                                                        <DropdownButton
                                                            id={`dropdown-button-drop_${i}`}
                                                            drop='start'
                                                            variant="secondary"
                                                            className='edit-btn'
                                                            title={<FiEdit2 size="16" color="#000" />}
                                                        >
                                                            <div className='p-2 d-flex'>
                                                                <input
                                                                    className='me-2 form-control font-12'
                                                                    onChange={(e) => setBid(e.target.value)}
                                                                    defaultValue={item.defaultBid ? HelperService.numberWithCommas(Number(item.defaultBid)) : 0}
                                                                    type="text"
                                                                />
                                                                <button
                                                                    className='loader-btn me-2 save-btns'
                                                                    id='savebgt'
                                                                    onClick={() => onStatusChange(item, 'BUDGET')}
                                                                >
                                                                    Save
                                                                </button>
                                                                <a href="javascript:void(0)" className='font-16 text-danger' onClick={() => onClose(i)}>
                                                                    <IoClose />
                                                                </a>
                                                            </div>
                                                        </DropdownButton>
                                                    )}
                                                    <Link to="#" className="ps-3"></Link>
                                                </>
                                            ),
                                        },
                                        {
                                            key: "ACOS",
                                            label: "ACOS",
                                            sortField: "ACOS",
                                            renderCell: (item) => `${item.ACOS ? item.ACOS : '0'}%`,
                                        },
                                        {
                                            key: "ROAS",
                                            label: "ROAS",
                                            sortField: "ROAS",
                                            renderCell: (item) => (item.ROAS ? item.ROAS : '0'),
                                        },
                                        {
                                            key: "impressions",
                                            label: "Impressions",
                                            sortField: "impressions",
                                            renderCell: (item) =>
                                                item.impressions ? HelperService.numberWithCommas(Number(item.impressions)) : '0',
                                        },
                                        {
                                            key: "sales",
                                            label: "Sales",
                                            sortField: "sales",
                                            renderCell: (item) =>
                                                item.sales ? "$" + HelperService.numberWithCommas(Number(item.sales)) : '0',
                                        },
                                        {
                                            key: "spend",
                                            label: "Spend",
                                            sortField: "spend",
                                            renderCell: (item) =>
                                                item.spend ? "$" + HelperService.numberWithCommas(Number(item.spend)) : '0',
                                        },
                                        {
                                            key: "orders",
                                            label: "Orders",
                                            sortField: "purchases",
                                            renderCell: (item) =>
                                                item.purchases ? HelperService.numberWithCommas(Number(item.purchases)) : '0',
                                        },
                                        {
                                            key: "clicks",
                                            label: "Clicks",
                                            sortField: "clicks",
                                            renderCell: (item) =>
                                                item.clicks ? HelperService.numberWithCommas(Number(item.clicks)) : '0',
                                        },
                                        {
                                            key: "cpc",
                                            label: "CPC",
                                            sortField: "cpc",
                                            renderCell: (item) => (item?.cpc ? item.cpc : 0),
                                        },
                                        {
                                            key: "ctr",
                                            label: "CTR",
                                            sortField: "ctr",
                                            renderCell: (item) => (item?.ctr ? `${item.ctr}%` : "0%"),
                                        },
                                        {
                                            key: "campaignType",
                                            label: "Campaign Type",
                                            sortField: "groupType",
                                            renderCell: (item) => {
                                                const t = String(item?.groupType || item?.campaignType || "");
                                                const short = t.includes("SP") ? "SP" : t.includes("SB") ? "SB" : t.includes("SD") ? "SD" : "-";
                                                const cls = short === "SP" ? "bg-primary" : short === "SB" ? "bg-info" : short === "SD" ? "bg-warning" : "bg-secondary";
                                                return <span className={`badge ${cls}`}>{short}</span>;
                                            },
                                        },
                                        {
                                            key: "targetingType",
                                            label: "Targeting Type",
                                            sortField: "targetingType",
                                            renderCell: (item) => {
                                                const raw = String(item?.targetingType || "").toUpperCase();
                                                if (!raw) return "-";
                                                const label = raw.charAt(0) + raw.slice(1).toLowerCase();
                                                return <span className="badge bg-secondary">{label}</span>;
                                            },
                                        },
                                        {
                                            key: "detailPageViews",
                                            label: "Detail Page Views",
                                            sortField: "detailPageViews",
                                            renderCell: (item) =>
                                                item?.detailPageViews
                                                    ? HelperService.numberWithCommas(Number(item.detailPageViews))
                                                    : '0',
                                        },
                                        {
                                            key: "addToCart",
                                            label: "Add to Cart",
                                            sortField: "addToCart",
                                            renderCell: (item) =>
                                                item?.addToCart
                                                    ? HelperService.numberWithCommas(Number(item.addToCart))
                                                    : '0',
                                        },
                                        {
                                            key: "brandedSearches",
                                            label: "Branded Searches",
                                            sortField: "brandedSearches",
                                            renderCell: (item) =>
                                                item?.brandedSearches
                                                    ? HelperService.numberWithCommas(Number(item.brandedSearches))
                                                    : '0',
                                        },
                                        {
                                            key: "newToBrandSales",
                                            label: "NTB Sales",
                                            sortField: "newToBrandSales",
                                            renderCell: (item) =>
                                                item?.newToBrandSales
                                                    ? "$" + HelperService.numberWithCommas(Number(item.newToBrandSales))
                                                    : '0',
                                        },
                                        {
                                            key: "newToBrandPurchases",
                                            label: "NTB Orders",
                                            sortField: "newToBrandPurchases",
                                            renderCell: (item) =>
                                                item?.newToBrandPurchases
                                                    ? HelperService.numberWithCommas(Number(item.newToBrandPurchases))
                                                    : '0',
                                        },
                                        {
                                            key: "newToBrandPercentage",
                                            label: "NTB %",
                                            sortField: "newToBrandPercentage",
                                            renderCell: (item) =>
                                                item?.newToBrandPercentage ? `${item.newToBrandPercentage}%` : "0%",
                                        },
                                    ];
                                    const visibleColumns = getVisibleColumns(columns, tableCols.config);
                                    return (
                                        <>
                                            <thead className='cursor-pointer'>
                                                <tr>
                                                    {visibleColumns.map((col) => (
                                                        <th
                                                            key={col.key}
                                                            className="text-nowrap"
                                                            onClick={
                                                                col.sortField
                                                                    ? () => sorting(currentSort, col.sortField as string)
                                                                    : undefined
                                                            }
                                                            style={{ cursor: col.sortField ? "pointer" : "default" }}
                                                        >
                                                            {col.label}
                                                            {col.sortField && currentColum === col.sortField &&
                                                                (currentSort === "DESC" ? (
                                                                    <FiChevronDown size={14} />
                                                                ) : (
                                                                    <FiChevronUp size={14} />
                                                                ))}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.map((item: any, i: number) => (
                                                    <tr key={i}>
                                                        {visibleColumns.map((col) => (
                                                            <td
                                                                key={col.key}
                                                                className={col.cellClassName || "text-nowrap"}
                                                            >
                                                                {col.renderCell(item, i)}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </>
                                    );
                                })()}
                            </table>
                            </div>
                        :
                            <div className="table-wrap position-relative">
                                <div className="no-data-flound">
                                    <div className="text-center">
                                        <img alt="" src={NoDataFound} width={110} className="mb-3" />
                                        <h3 className="text-secondary font-12">{t('Common.No_Record_Found')}</h3>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>

            {props?.come_from === "CAMPAIGN_DETAILS" && (
                <AddAdGroupDrawer
                    isShow={showAddAdGroup}
                    onClose={() => setShowAddAdGroup(false)}
                    onSaved={() => getList()}
                    campaignId={campaignData?.campaignId ?? ""}
                    campaignType={campaignData?.campaignType}
                />
            )}

            <EditColumnsPanel columns={panelColumns} controller={tableCols} />
        </>
    )
}

export default AdGroupsList;
